<div class="metric-box"
     [style.left.px]="x"
     [style.top.px]="y"
     [style.z-index]="zIndex"
     draggable="true"
     (dragstart)="onDragStart($event)">

  <!-- Metric Header -->
  <div class="metric-header">
    <div class="metric-title">
      <mat-icon class="metric-icon">functions</mat-icon>
      <span class="metric-name">{{ metric.metricName }}</span>
    </div>
    <button
      class="remove-btn"
      (click)="onRemove()"
      mat-icon-button
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Metric Content -->
  <div class="metric-content">
    <div class="metric-field"
         [class.selected]="isMetricSelected()"
         (click)="onMetricClick()">
      <span class="field-name">{{ metric.metricName }}</span>
    </div>
  </div>
</div>
